<template>
  <div class="replacementmonthlystatistics__report__view">    
    <div class="reports__subheader">

    </div>
    <div class="box is-primary">
      <h2 class="title is-3">
        {{ isNewGroup ? "Opret Ny Grupper" : "Redigér Gruppe" }}
      </h2>

      <section class="personal-info">        
        <b-field label="Er gruppen aktiv"
                class="column">
          <div class="fake-control" style="width: 200px">
            <b-switch v-model="isActive"
                      type="is-primary"
                      size="is-medium">{{!isActive ? 'Nej' : 'Ja'}}</b-switch>
          </div>
        </b-field>
      </section>
      <!-- Personal info -->
      <section class="personal-info">
        <div class="columns">
          <b-field label="Navn"
                   class="column">
            <b-input v-model="formGroup.title" />
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Hverdage"
                   class="column">
            <b-input v-model="formGroup.atWorkWeekDays" />
          </b-field>
          <b-field label="Lørdage"
                   class="column">
            <b-input v-model="formGroup.atWorkWeekSaturday" />
          </b-field>
          <b-field label="Søndage"
                   class="column">
            <b-input v-model="formGroup.atWorkWeekSunday" />
          </b-field>
        </div>
        
        <div class="columns">
          <b-field label="Helligdag Hverdage"
                   class="column">
            <b-input v-model="formGroup.atWorkHolidayWeekdays" />
          </b-field>
          <b-field label="Helligdag Weekend"
                   class="column">
            <b-input v-model="formGroup.atWorkHolidayWeekend" />
          </b-field>
        </div>
      </section>

      <section>          
        <h2 class="title is-3">Ins. i gruppen</h2>
        <div v-for="(item, index) in formGroup.employees" :key="index">
          <div class="columns">
            <b-field label="Navn"
                    class="column">
              <span style="font-weight: bold; float:left;">{{ getName(item) }}</span>
            </b-field>
            
            <b-field label="Hverdagsgruppe"
                    class="column">
              <b-select v-model="item.weekDayGroupId" expanded>
                <option v-for="(item, index) in groupNumbers" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </b-select> 
            </b-field>
            <b-field label="Weekendsgruppe"
                    class="column">
              <b-select v-model="item.weekendGroupId" expanded>
                <option v-for="(item, index) in groupNumbers" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </b-select> 
            </b-field>
            <b-field label="Kreds"
                    class="column">
              <b-select v-model="item.circleId" expanded @input="circleChanged">
                <option v-for="(item, index) in filteredCircles" :key="index" :value="item.id">
                  {{ item.title }}
                </option>
              </b-select> 
            </b-field>
          </div>
          
          <div class="columns">
            <b-field label="Række gølge"
                    class="column">
              <b-input v-model="item.orderNumber" />
            </b-field>
            <b-field label="Gruppe afløser"
                    class="column">
              <div class="fake-control" style="width: 200px">
                <b-switch v-model="item.isGroupReplacement"
                          type="is-primary"
                          size="is-medium">{{item.isGroupReplacement ? 'Ja' : 'Nej'}}</b-switch>
              </div>
            </b-field>
            <b-field label="Bagvagt" class="column">
              <div class="fake-control" style="width: 200px">
                <b-switch v-model="item.isStandIn"
                          type="is-primary"
                          size="is-medium">{{item.isStandIn ? 'Ja' : 'Nej'}}</b-switch>
              </div>
            </b-field>
            
            <b-field label="Tilgængelig" class="column" width="400">
              <div v-for="(day, dayIdx) in item.weekdays" :key="dayIdx">
                <b-field :label="day.name" class="column is-2">
                  <b-checkbox v-model="day.isChecked" type="checkbox"></b-checkbox>
                </b-field>
              </div>
            </b-field>
            <b-field label="Handling"
                    class="column">
              <b-button @click="remove(item)"
                        expanded>
                Fjern
              </b-button>
            </b-field>
          </div>
        </div>
            
        <div class="columns">
          <div class="column">
                    
              <b-select v-model="regionEmployee" expanded @input="filterEmployee">
                <option v-for="(item, index) in filteredEmployees" :key="index" :value="item">
                  {{ item.number }} - {{ item.name }}
                </option>
              </b-select>  
            </div>
            
          <div class="column is-3">
            <b-button @click="add"
                      v-if="regionEmployee"
                      expanded>
              Tilføj ins. til gruppen
            </b-button>
            
          </div>
        </div>
      </section>

      <!-- Buttons -->
      <div class="columns">
        <div class="column"></div>
        <div class="column is-3">
          <b-button type="is-outline"
                    @click="goBack"
                    expanded>
            Afbryd
          </b-button>
        </div>
        <div class="column is-3" v-if="hasEditRights">
          <b-button :type="{'is-primary': !hasError, 'is-danger': hasError}"
                    @click="submit"
                    :loading="loading && !hasError"
                    expanded>
            {{ isNewGroup ? "Opret Gruppe" : "Gem Ændringer" }}
          </b-button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../../enums/APISTATE";
import moment, { ISO_8601 } from 'moment';

export default {
  name: "groups-view",
  props: {
    groupId: {
      type: String,
      default: null,
    },
  },
  data: () => ({ 
      formGroup: {
        employees: []
      },
      regions: [
        { value: 'syd', text: 'syd' },
        { value: 'nord', text: 'nord' },
        { value: 'begge', text: 'begge' }
      ],
      regionFilter: "syd",
      regionEmployee: null,
      groupNumbers: [{id: 0, name: '0'},{id: 1, name: '1'},{id: 2, name: '2'},{id: 3, name: '3'},{id: 4, name: '4'},{id: 5, name: '5'},{id: 6, name: '6'},{id: 7, name: '7'},{id: 8, name: '8'}],
      isActive: true
  }),
  async mounted() {

    await this.getAllEmployees();
    await this.loadCircles();

    if(this.groupId){
      await this.init(this.groupId);
    } else {
      this.formGroup = {
        employeeId: this.currentUser.id,
        title: 'Ny gruppe',
        atWorkWeekDays: 1,
        atWorkWeekSaturday: 1,
        atWorkWeekSunday: 1,
        atWorkHolidayWeekdays: 1,
        atWorkHolidayWeekend: 1,
        employees: []
      };
      if(this.isAdmin) {
        return;
      }

      this.formGroup.employees.push({
        employeeId: this.currentUser.id,
        employeeName: this.currentUser.name,
        groupId: this.groupId ? this.groupId : "00000000-0000-0000-0000-000000000000",
        groupName: "",
        circleId: this.circles.find(o => o.title === "Kreds 0") ? this.circles.find(o => o.title === "Kreds 0").id : this.circles[0].id,
        hasEditRights: true,
        region: "",
        weekDayGroupId: 0,
        weekendGroupId: 0,
        number: 0,
        _LatestUpdate: new Date(),
        _UpdateTag: this.currentUser.id,
        _UpdatedBy: this.currentUser.id,
        _UpdatedByName: "system",
        weekdays: this.allEmployees.find(o => o.id === this.currentUser.id).weekdays
      });
    } 
  },
  computed: {
    ...mapGetters("groupStore", ["groupState", "group","usersForGroupApiState","usersForGroup"]),
    ...mapGetters("employees", ["allEmployees", "allEmployeeApiState"]),
    ...mapGetters("circles", ["circles", "circleApiState"]),
    ...mapGetters(["currentUser", "isAdmin", "hasEditRights"]),
     loading() {
      return this.groupState !== ApiState.LOADED && this.usersForGroupApiState !== ApiState.LOADED && this.allEmployeeApiState !== ApiState.LOADED;
    },
    hasError() {
      return this.groupState === ApiState.ERROR;
    },
    isNewGroup() {
        return !this.groupId;
    },
    filteredCircles(){
      if(this.circles) {
        return this.circles
          .filter((o) => o.title.toLowerCase().includes('kreds'));
          //.filter(o => o.title.toLowerCase().includes('kreds') === false);
      }

      return this.circles;
    },
    filteredEmployees(){
      if(this.allEmployees) {
        return this.allEmployees
          .filter((o) => o.circleId);
      }

      return this.allEmployees;
    },
    sortedEmployees() {
      console.log("sortedEmployees");
      if(this.formGroup.employees) {
        var compare = (a, b) => {
          if(a.orderNumber < b.orderNumber) {                
            return -1;
          }

          if(a.orderNumber > b.orderNumber) {        
            return 1;
          }

          return 0;
        }

        let result = this.formGroup.employees.filter(o => o).sort(compare);
        if(result) {
          return result;
        }
      }
      return this.formGroup.employees;
    }
  },
  methods: {
    ...mapActions("groupStore", ["getGroupById", "getUsersGorGroup", "updateGroup","createGroup"]),
    ...mapActions("circles", ["loadCircles", ]),
    ...mapActions("employees", ["getAllEmployees"]),
    dateFormat(arg) {
        return moment(arg).format('YYYY-MM-DD');
    },
    goBack() {
      this.$router.go(-1);
    },
    filterEmployee(employee) {
      this.regionEmployee = employee;
    },
    circleChanged(circle) {
    },
    getName(arg){
      if(arg.number) {
        return `${arg.employeeName} - ${arg.number}`;
      }
        return `${arg.employeeName}`;
    },
    async init(groupId) {
      await this.getGroupById(groupId);
      await this.getUsersGorGroup(groupId);
      this.formGroup = { ...this.group };
      this.formGroup.employees = this.usersForGroup;

      if(this.formGroup.employees) {
        this.formGroup.employees = this.formGroup.employees.sort(this.compare);
      }

      this.isActive = this.formGroup.isRemoved !== true;
    },
    async remove(arg) {
      if(arg) {
        this.formGroup.employees = this.formGroup.employees.filter(o => o.employeeId !== arg.employeeId); 
      }
    },
    async add() {
      if(this.formGroup.employees.find(o => o.employeeId === this.regionEmployee.id)){
        return;
      }

      this.formGroup.employees.push({
          employeeId: this.regionEmployee.id,
          employeeName: this.regionEmployee.name,
          groupId: this.groupId ? this.groupId : "00000000-0000-0000-0000-000000000000",
          circleId: this.regionEmployee.circleId,
          groupName: "5",
          hasEditRights: false,
          region: "nord",
          weekDayGroupId: 0,
          weekendGroupId: 0,
          number: this.regionEmployee.number,
          _LatestUpdate: new Date(),
          _UpdateTag: this.regionEmployee.id,
          _UpdatedBy: this.currentUser.id,
          _UpdatedByName: this.currentUser.name,
        weekdays: this.allEmployees.find(o => o.id === this.regionEmployee.id).weekdays
      });
      console.log(this.formGroup.employees);
      this.regionEmployee = null;
    },
    async submit() {
      this.formGroup.isRemoved = this.isActive === false;
      if (this.isNewGroup) {
        this.formGroup.employeeId = this.currentUser.id;
        if(this.formGroup.employees.length === 0) {          
          this.formGroup.employees.push({
              employeeId: this.currentUser.id,
              employeeName: "",
              groupId: this.groupId ? this.groupId : "00000000-0000-0000-0000-000000000000",
              groupName: "",
              circleId: "00000000-0000-0000-0000-000000000000",
              hasEditRights: true,
              region: "",
              weekDayGroupId: 0,
              weekendGroupId: 0,
              number: 0,
              _LatestUpdate: new Date(),
              _UpdateTag: this.currentUser.id,
              _UpdatedBy: this.currentUser.id,
              _UpdatedByName: "system",
              weekdays: this.allEmployees.find(o => o.id === this.currentUser.id).weekdays
          });
        }

        await this.createGroup(this.formGroup);
      } else {
        await this.updateGroup(this.formGroup);
        if(this.formGroup.employees) {
          this.formGroup.employees = this.formGroup.employees.sort(this.compare);
        }
      }

      if (this.groupState !== ApiState.ERROR) {
        await this.init(this.group.id);
        if(this.isNewGroup) {          
          let path = `/configuration-user/my-groups/${this.group.id}/group`;

          if(this.isAdmin) {
            path = `/configuration/groups/${this.group.id}/group`;
          }
          this.$buefy.dialog.alert({
            title: "Success",
            message: `Gruppe ${this.isNewGroup ? "oprettet" : "opdateret"}`,
            type: "is-success",
            canCancel: false,
            onConfirm: () => this.$router.push(path),
          });
        } else {          
          this.$buefy.dialog.alert({
            title: "Success",
            message: `Gruppe ${this.isNewGroup ? "oprettet" : "opdateret"}`,
            type: "is-success",
            canCancel: false,
          });
        }
      } else {
        this.$buefy.dialog.alert({
          title: "Fejl",
          message: "Kunne ikke oprette gruppe",
          type: "is-danger",
        });
      }
    },
    compare(a, b) {    
        if(a.weekDayGroupId < b.weekDayGroupId) {                
          return -1;
        }

        if(a.weekDayGroupId > b.weekDayGroupId) {        
          return 1;
        }

        if(a.isGroupReplacement) {
          return 1;
        }

        if(b.isGroupReplacement) {
          return -1;
        }

        if(a.orderNumber < b.orderNumber) {                
          return -1;
        }

        if(a.orderNumber > b.orderNumber) {        
          return 1;
        }

        return 0;
    }
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
